import { c as _c } from "react/compiler-runtime";
import './nav-card.scss';
import { Skeleton } from '@sola/ark-core/atoms/skeleton/skeleton.tsx';
import { cn } from '@sola/ark-core/utils/helpers.ts';
export const NavCardSkeleton = t0 => {
  const $ = _c(9);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("NavCard w-full max-w-sm mx-auto flex flex-cols items-center", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="NavCard__media"><Skeleton width="124px" height="124px" style={{
        aspectRatio: "square"
      }} className="NavCard__image" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div><Skeleton height="2rem" width="60%" /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="mt-snug-xl"><Skeleton height="1rem" width="90%" /></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="mt-snug-md"><Skeleton height="1rem" width="70%" /></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="NavCard__content w-full">{t3}{t4}{t5}<div className="mt-comfy-sm"><Skeleton height="1rem" width="20%" /></div></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t1) {
    t7 = <div className={t1}>{t2}{t6}</div>;
    $[7] = t1;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
};